import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { useFormatDuration } from '@root/shared'
import { dateByMinuteAtom } from '@root/shared/lib'
import { CrossIcon } from '@root/shared/ui-kit'

import { CurrencyBannerFooter } from './currency-banner-footer'

import type { ArchivedPremium } from '@root/entities/premium/model/premium-meta'

type Props = {
  archivedPremium: ArchivedPremium
  onReset?: () => void
}

export const ArchivedPremiumBannerFooter = ({
  archivedPremium,
  onReset,
}: Props) => {
  const { formatDuration } = useFormatDuration()
  const expiresAt = archivedPremium.expiresAt
  const owner = archivedPremium.owner
  const [now] = useAtom(dateByMinuteAtom)

  const premiumTimeLeft = useMemo(
    () =>
      formatDuration({
        startAt: now,
        endAt: expiresAt,
        mode: 'singleUnitShort',
      }),
    [now, expiresAt, formatDuration],
  )

  return (
    <CurrencyBannerFooter
      status={'archived'}
      owner={owner}
      premiumTimeLeft={premiumTimeLeft}
      slotResetButton={
        onReset ? (
          <ResetButton type="button" onClick={onReset}>
            <CrossIcon size={16} />
          </ResetButton>
        ) : undefined
      }
    />
  )
}

const ResetButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;

  margin: -2px 0 -2px auto;

  border-radius: 5px;
  background: var(--background-2);

  color: var(--text-11);

  &:hover {
    background: var(--background-4);
    color: var(--text-12);
  }
`
